import { faEllipsisVertical, faBan } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@shared/components/ui/dropdown-menu';
import { Button } from '@shared/components/ui/button';

interface BlockedStorageDropdownActionsProps {
  blockId: number; // ID del registro de bloqueo (accounting_storage_blocks.id)
  onAction?: (action: string, blockId: number) => void;
}

/**
 * Componente de acciones para storages bloqueados
 * Muestra la opción de Desbloquear
 */
export const BlockedStorageDropdownActions = ({ blockId, onAction }: BlockedStorageDropdownActionsProps) => {
  const { t } = useTranslation('eligibleStorageModule');

  const handleAction = (actionType: string) => {
    if (onAction) {
      onAction(actionType, blockId);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="h-8 w-8 p-0" data-testid="blocked-storage-dropdown-trigger">
          <FontAwesomeIcon icon={faEllipsisVertical} className="text-icons" />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        align="end"
        className="w-48 border-card-border"
        data-testid="blocked-storage-dropdown-content"
      >
        <DropdownMenuItem
          onClick={() => handleAction('unblock')}
          className="whitespace-nowrap"
          data-testid="blocked-storage-action-unblock"
        >
          <FontAwesomeIcon icon={faBan} className="mr-1 !w-3 !h-3 !text-content-primary" />
          {t('actions.unblock', 'Desbloquear')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
